// extracted by mini-css-extract-plugin
module.exports = {"name":"_aeda6e4b","link":"_869da96c"};